import { updateClientContext } from '@ms/yammer-telemetry-store';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { getTeamsContext } from 'state/teamsContext/selectors';

type UpdateClientContextWithHostMetadata = () => void;
export const updateClientContextWithHostMetadata: UpdateClientContextWithHostMetadata = () => {
  const context = getTeamsContext();

  const clientContext = getClientContext({
    hostSessionId: context?.sessionId,
    appSessionId: context?.appSessionId,
    appManifestVersion: context?.manifestVersion,
    hostAppName: context?.hostAppName,
    hostClientType: context?.hostClientType,
    hostRingId: context?.ringId,
    hostLaunchId: context?.appLaunchId,
  });

  updateClientContext(clientContext);
};
